import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@mode/capra';
import { PlanCardComponent } from '../plan-card/plan-card.component';

@Component({
  selector: 'mode-free-plan',
  standalone: true,
  imports: [CommonModule, IconComponent, PlanCardComponent],
  templateUrl: './free-plan.component.html',
  styleUrls: ['./free-plan.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreePlanComponent {
  public readonly planFeatures: readonly string[] = [
    'Free for up to 3 users',
    '10MB/query',
    '5GB monthly throughput',
    'SQL, Python, R, & Data Viz',
  ];
  @Input() isUpgradePlansFlow = false;
}
